import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import styles from "./index.module.css";
import Logo from "../../images/WWLogo.gif";

export default function Header() {
	const [hide, setHide] = useState("none");
	const [toggle, setToggle] = useState(true);
	const [width, setWidth] = useState(window.innerWidth);
	const mobile = 550;

	function toggleHide() {
		return hide === "none" ? setHide("block") : setHide("none");
	}

	function handleToggle() {
		return toggle === true ? setToggle(false) : setToggle(true);
	}

	useEffect(() => {
		const handleWindowResize = () => setWidth(window.innerWidth);
		window.addEventListener("resize", handleWindowResize);
		return () => window.removeEventListener("resize", handleWindowResize);
	}, []);

	return (
		<div className={styles.container}>
			<div className={styles.figureContainer}>
				<figure>
					<Link to="/">
						<img src={Logo} alt="logo" />
					</Link>
				</figure>
			</div>
			<nav className={styles.nav}>
				<ul className={styles.ul}>
					<Link to="/about" className={styles.linkStyle}>
						ABOUT US
					</Link>
					{width > mobile ? (
						// DESKTOP DROPDOWN
						<Link to="/franchise_oppertunities" className={styles.linkStyle} onMouseEnter={toggleHide} onMouseLeave={toggleHide}>
							FRANCHISE INFORMATION
							<div className={styles.dropdown} style={{ display: hide }}>
								<Link to="/franchise_oppertunities" className={styles.linkStyle}>
									FRANCHISE OPPORTUNITIES
								</Link>
								<Link to="/reasons_to_invest" className={styles.linkStyle}>
									REASONS TO INVEST
								</Link>
								<Link to="/investment_requirements" className={styles.linkStyle}>
									INVESTMENT REQUIREMENTS
								</Link>
								<Link to="/faqs" className={styles.linkStyle}>
									FAQ'S
								</Link>
								<Link to="/support" className={styles.linkStyle}>
									SUPPORT
								</Link>
								<Link to="/request_information" className={styles.linkStyle}>
									REQUEST INFORMATION
								</Link>
							</div>
						</Link>
					) : (
						// MOBILE DROPDOWN
						<>
							<Link to="/franchise_oppertunities" className={styles.linkStyle} onClick={handleToggle}>
								FRANCHISE INFORMATION
							</Link>
							<div onMouseLeave={handleToggle} className={toggle ? styles.dropdown : styles.dropdownShow}>
								<Link to="/franchise_oppertunities" className={styles.linkStyle}>
									FRANCHISE OPPORTUNITIES
								</Link>
								<Link to="/reasons_to_invest" className={styles.linkStyle}>
									REASONS TO INVEST
								</Link>
								<Link to="/investment_requirements" className={styles.linkStyle}>
									INVESTMENT REQUIREMENTS
								</Link>
								<Link to="/faqs" className={styles.linkStyle}>
									FAQ'S
								</Link>
								<Link to="/support" className={styles.linkStyle}>
									SUPPORT
								</Link>
								<Link to="/request_information" className={styles.linkStyle}>
									REQUEST INFORMATION
								</Link>
							</div>
						</>
					)}
					<Link to="/request_information" className={styles.linkStyle}>
						GET STARTED
					</Link>
				</ul>
			</nav>
		</div>
	);
}
